import { isAnswerDataKeypadTypes, isAutoScorableType } from '~/@entities/Problem'
import type { SchoolType } from '~/@entities/SchoolSystem'

import { formatSubmittedAnswer } from './formats'
import {
  isSubmittedResult,
  isWrongOrUnknownResult,
  type ScorableProblem,
  type ScoringItem,
  type ScoringResult,
} from './schemas'

// 문항 채점을 조립한다. 채점 기록·문제는 서버 응답에서, 문항 번호·자동채점 여부·학년은 화면이 아는
// 학습물에서 온다. 조각마다 서버 응답이 달라(학습지·시험·교재·CAS·오답학습) 조립만 한곳에 모은다.
export type ScoringItemInput<Target, P extends ScorableProblem> = {
  target: Target
  problem: P
  record: {
    result: ScoringResult
    userAnswer: string | null
    userAnswers?: readonly (string | null)[] | null
    updateDatetime?: string | null
  }
  content: {
    label: string
    autoScorable: boolean
    schoolType?: SchoolType
    gradeLabel: string
  }
  answerLength: number
}

export const toScoringItem = <Target, P extends ScorableProblem>({
  target,
  problem,
  record,
  content,
  answerLength,
}: ScoringItemInput<Target, P>): ScoringItem<Target, P> => {
  const userAnswer = record.userAnswer === '' ? null : record.userAnswer
  const userAnswers = record.userAnswers ?? null
  return {
    ...target,
    result: record.result,
    userAnswer,
    userAnswers,
    updateDatetime: record.updateDatetime ? new Date(record.updateDatetime) : null,
    problem,
    label: content.label,
    autoScorable: content.autoScorable,
    problemAutoScorable: isAutoScorableType(problem.autoScoredType),
    schoolType: content.schoolType,
    gradeLabel: content.gradeLabel,
    submittedAnswer: formatSubmittedAnswer({ userAnswer, userAnswers }),
    isSubmitted: isSubmittedResult(record.result),
    isWrongOrUnknown: isWrongOrUnknownResult(record.result),
    answerUnits: isAnswerDataKeypadTypes(problem.keypadTypes) ? null : problem.answerUnits,
    answerLength,
  }
}
